import Vue from 'vue'
import {
  Button,
  Collapse,
  Dialog,
  Dropdown,
  Field,
  Input,
  Loading,
  Menu,
  Notification,
  Breadcrumb,
  Checkbox,
  Pagination,
  Radio,
  Sidebar,
  Skeleton,
  Tag,
  Toast,
} from 'buefy'

Vue.use(Button)
Vue.use(Collapse)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(Field)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Menu)
Vue.use(Notification)
Vue.use(Breadcrumb)
Vue.use(Checkbox)
Vue.use(Pagination)
Vue.use(Radio)
Vue.use(Sidebar)
Vue.use(Skeleton)
Vue.use(Tag)
Vue.use(Toast)
